import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageHeadlineProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
}

export function PageHeadline({ eyebrow, title, subtitle, className }: PageHeadlineProps) {
  return (
    <div className={cn("flex min-w-0 flex-col gap-2", className)}>
      {eyebrow ? (
        <p className="text-[12px] font-bold uppercase tracking-[1.2px] text-[#2563eb]">{eyebrow}</p>
      ) : null}
      <h1 className="break-words text-[22px] font-bold leading-tight tracking-tight text-[#1a1a1a] sm:text-[28px]">
        {title}
      </h1>
      {subtitle ? <p className="break-words text-[15px] text-[#6c757d]">{subtitle}</p> : null}
    </div>
  );
}
